<template>
	<a-drawer title="账号报价变更申请" width="70%" :closable="false" :visible="visibleEdit">
		<div style="width: 80%;margin:30px auto">
			<UserTaskRecord :businessType="'account'" :uuid="accountPriceApply.puuid"></UserTaskRecord>
		</div>
		<a-divider>申请信息</a-divider>
		<a-form :form="form" style="width: 80%;margin:30px auto">
			<a-form-item labelAlign="left" label="申请标题" v-bind="formItemLayout">
				{{accountPriceApply.title}}
			</a-form-item>
			<a-form-item labelAlign="left" v-if="accountPriceApply.brokerApprovalOpinion" label="备注" v-bind="formItemLayout">
				{{accountPriceApply.brokerApprovalOpinion}}
			</a-form-item>
		</a-form>
		<div style="width: 80%;margin:30px auto" class="formItemLayoutBackground">
			<PlatformAccountInfo :accountPriceApply="accountPriceApply" ></PlatformAccountInfo>
			<WeiboPrice :accountPriceApply="accountPriceApply" :canEdit="true"></WeiboPrice>
			<WeiboCollectionPrice :accountPriceApply="accountPriceApply" :canEdit="true"></WeiboCollectionPrice>
			<WeixinPrice :accountPriceApply="accountPriceApply" :canEdit="true"></WeixinPrice>
			<DouyinPrice :accountPriceApply="accountPriceApply" :canEdit="true"></DouyinPrice>
			<BilibiliPrice :accountPriceApply="accountPriceApply" :canEdit="true"></BilibiliPrice>
			<RedbookPrice :accountPriceApply="accountPriceApply" :canEdit="true"></RedbookPrice>
			<MomentsPrice :accountPriceApply="accountPriceApply" :canEdit="true"></MomentsPrice>
			<KuaishouPrice :accountPriceApply="accountPriceApply" :canEdit="true"></KuaishouPrice>
			<ChannelsPrice :accountPriceApply="accountPriceApply" :canEdit="true"></ChannelsPrice>
			<div style="margin-top: 10px;">
				*注：不同颜色代表不同报价调整类型，
				<span style="background-color: beige;">淡黄色</span>原价格，
				<span style="background-color: yellow;">黄色</span>修改，
				<span style="background-color: palegreen;">绿色</span>新增，
				<span style="background-color: orangered;">红色</span>删除。
			</div>
		</div>
		<div class="drawer-bootom-button">
			<a-popconfirm title="确定放弃申请吗？" @confirm="onClose" okText="确定" cancelText="取消">
				<a-button style="margin-right: .8rem">取消</a-button>
			</a-popconfirm>
			<a-popconfirm title="该账号报价申请审批完成后生效，生效于下月一日？" @confirm="handleSubmit" okText="确定" cancelText="取消">
				<a-button :loading="loading" type="primary">提交申请</a-button>
			</a-popconfirm>
		</div>
		<a-modal title="选择审批人" :visible="visible"  @ok="submit" width="40%" @cancel="visible=false">
			<div style="margin-bottom: 15px;" >
				<span class="visibleName">经纪部审批人</span>
				<a-select showSearch optionFilterProp="children" v-model="brokerId" placeholder="请选择经纪部审批人" style="width: 60%"  >
					<a-select-option v-if="item.userId != 1" v-for="item in brokerArr" :key="item.userId">{{item.realname}}</a-select-option>
		    	</a-select>
			</div>
		</a-modal>
	</a-drawer>
</template>

<script>
	import WeiboPrice from './weiboPrice';
	import WeiboCollectionPrice from './weiboCollectionPrice';
	import WeixinPrice from './weixinPrice';
	import DouyinPrice from './douyinPrice';
	import BilibiliPrice from './bilibiliPrice';
	import RedbookPrice from './redbookPrice';
	import MomentsPrice from './momentsPrice';
	import KuaishouPrice from './kuaishouPrice';
	import ChannelsPrice from './channelsPrice';
	import UserTaskRecord from './userTaskRecord';
	import PlatformAccountInfo from './platformAccountInfo';

	const formItemLayout = {
		labelCol: {
			span: 2
		},
		wrapperCol: {
			span: 22
		}
	}
	export default {
		props: {
			visibleEdit: {
				default: false
			},
		},
		components:{
			WeiboPrice,
			WeiboCollectionPrice,
			WeixinPrice,
			DouyinPrice,
			BilibiliPrice,
			RedbookPrice,
			MomentsPrice,
			KuaishouPrice,
			ChannelsPrice,
			UserTaskRecord,
			PlatformAccountInfo
		},
		data() {
			return {
				formItemLayout,
				form: this.$form.createForm(this),
				id: null,
				loading: false,
				accountPriceApply: {},
				introPlaceholder: "请说明账号的粉丝数及其他信息",
				brokerShow: false,
				visible: false,
				confirmLoading: false,
				brokerId: null,
				brokerArr: []
			}
		},
		mounted(){
			this.$get('user/listUserByRole/netRedMediaBrokerRole').then(res => {
				this.brokerArr = res.data;
			});

		},
		methods: {
			init(id) {
				this.id = id;
				this.getById();
			},

			setFormValues({ ...item}) {
				this.id = item.childId;
				this.brokerId = item.approveBrokerId;
				this.getById();
				let fields = ['title','intro'];
				Object.keys(item).forEach((key) => {
					if(fields.indexOf(key) !== -1) {
						this.form.getFieldDecorator(key);
						let obj = {};
						obj[key] = item[key];
						this.form.setFieldsValue(obj);
					}
				})
			},
			handleSubmit() {
				if (this.brokerShow) {
					this.visible = true;
				} else {
					this.submit();
				}

			},
			submit() {
				let platformTypeArr = this.platformTypeArr;
				if(this.brokerShow && this.brokerId == null){
					this.$message.warning("存在申请账号经纪人为空,请选择经济部审批人");
					return;
				}
				let data = {
					id: this.id,
					brokerId: this.brokerId
				}
				this.loading = true;
				this.visible = false;
				this.$post('accountPriceApply/saveAccountPriceApply', data).then(r => {
					this.loading = false;
					this.form.resetFields();
					this.$message.success("操作成功");
					this.$emit('accountPriceHome');
					this.$emit('success');
				}).catch(res => {
					this.loading = false;
				})
			},
			getById(){
				this.accountPriceApply = {};
				this.brokerShow = false;
				this.$get("accountPriceApply/getById",{id: this.id}).then(res => {
					this.accountPriceApply = res.data;
					if(this.accountPriceApply.brokerId == null){
						this.brokerShow = true;
					}
					if(this.accountPriceApply.platformType == 'douyin'){
						this.introPlaceholder = '①达人优秀案例②互动率情况③达人性别④达人所属地域⑤是否开通购物车⑥其他信息';
					} else{
						this.introPlaceholder = '请说明账号的粉丝数及其他信息';
					}
					if(this.accountPriceApply.platformType == "weibo" ||  this.accountPriceApply.platformType == "channels"){
						let arr = [];
						if (this.accountPriceApply.enterPlatformType != null && this.accountPriceApply.enterPlatformType != '') {
							this.accountPriceApply.enterPlatformType.split(",").forEach(e => {
								arr.push(e);
							})
						}
						this.accountPriceApply.enterPlatformType = arr;
					}
				});
			},
			onClose() {
				this.form.resetFields();
				this.$emit('close')
			},
		},
	}
</script>
<style lang="less" scoped>
	.formItemLayoutBackground{
		/deep/.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content{
			background-color: #fff !important;
			border: 1px solid #E8E8E8 !important;
		}
		/deep/ table {
			border-left: 1px solid black !important;
			border-bottom: 1px solid black !important;
		}
		/deep/ table > .ant-table-thead > tr > th {
			border-right: 1px solid black !important;
			border-top: 1px solid black !important;
		}
		/deep/ table > .ant-table-tbody > tr > td {
			border-right: 1px solid black !important;
			border-top: 1px solid black !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/account/accountChange/accountPrice/accountPriceApplyEdit.vue